/**
 * Simulation Controls Component
 * Implements PRD FR-29
 */

import { useSimulationStore } from '../state/simulationStore';

export function SimulationControls() {
  const {
    simulation,
    runNewSimulation,
    runDeterministicSimulation,
    newRandomPath,
    stepForward,
    stepBackward,
  } = useSimulationStore();

  const hasSimulation = simulation !== null;
  const currentTime = simulation?.currentTime ?? 1;
  const canStepBack = hasSimulation && currentTime > 1;
  const canStepForward = hasSimulation && currentTime < 3;

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">Controls</h2>

      <div className="space-y-3">
        {/* Run Simulation Button */}
        <button
          onClick={() => runNewSimulation()}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
        >
          Run Simulation
        </button>

        {/* Deterministic Mode */}
        <button
          onClick={runDeterministicSimulation}
          className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-sm"
        >
          Run Deterministic (ε = 0)
        </button>

        {/* New Random Path */}
        <button
          onClick={newRandomPath}
          disabled={!hasSimulation}
          className="w-full px-4 py-2 bg-purple-100 text-purple-700 rounded-md hover:bg-purple-200 transition-colors text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          New Random Path
        </button>

        {/* Step Controls */}
        <div className="flex gap-2 pt-2">
          <button
            onClick={stepBackward}
            disabled={!canStepBack}
            className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            ◀ Back
          </button>
          <button
            onClick={stepForward}
            disabled={!canStepForward}
            className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Forward ▶
          </button>
        </div>

        {/* Current Time Display */}
        {hasSimulation && (
          <div className="text-center text-sm text-gray-600 pt-2">
            Current: <span className="font-mono font-bold">t = {currentTime}</span>
          </div>
        )}
      </div>
    </div>
  );
}
